<template>
    <Dropdown
        class="order-time-dropdown"
        v-model="selectedTime"
        panel-class="order-time-dropdown-panel scrollable-element"
        :options="currentOptions"
        optionLabel="label"
        optionValue="value"
        :disabled="props.disabled"
        scrollHeight="300px"
    />
</template>

<script setup lang="ts">
    import type { IFulfillmentTimeSlotDto } from "@/data/model/Customer";
    import { computed, ref, watch } from "vue";

    import Dropdown from "primevue/dropdown";

    // define props
    const props = defineProps<{
        modelValue: any | null;
        options: IFulfillmentTimeSlotDto[] | undefined;
        disabled: boolean;
        inputId?: string;
    }>();

    // define emits
    const emit = defineEmits(["update:modelValue"]);

    // define state
    const selectedTime = ref(props.modelValue);

    // define computed
    const currentOptions = computed(() => {
        return (
            props.options?.map((x) => {
                return {
                    label: x.startTime.substring(0, 5),
                    value: x.startTime,
                };
            }) ?? []
        );
    });

    // event handlers
    watch(selectedTime, (newSelectedTime) => {
        emit("update:modelValue", newSelectedTime);
    });

    // update watchers
    watch(
        () => props.modelValue,
        (newSelectedTime) => {
            selectedTime.value = newSelectedTime;
        }
    );
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";

    .order-time-dropdown {
        text-align: left;
        color: colors.$fontColor;
        min-width: 100px;
        width: 300px;
        border-radius: 4px;
        box-shadow: none !important;

        display: inline-flex;
        cursor: pointer;
        position: relative;
        user-select: none;

        .p-dropdown-label {
            display: block;
            white-space: nowrap;
            overflow: hidden;
            flex: 1 1 auto;
            width: 1%;
            text-overflow: ellipsis;
            cursor: pointer;
        }

        .p-dropdown-trigger {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
        }

        > .p-inputtext {
            padding: 0.75em;
            font-size: 18px !important;
        }
    }

    .order-time-dropdown-panel {
        .p-dropdown-items {
            .p-dropdown-item {
                color: colors.$fontColor;
                border-bottom: 1px solid colors.$greyBorder !important;
                padding: 0.75em 1em;

                &:last-child {
                    border-bottom: none !important;
                }
            }
        }
    }
</style>
